module.exports = __webpack_public_path__ + "img/page02_text.e259f88c.png";